export enum Messages {
  'de-DE' = 'Mensagem',
  'en-DE' = 'MensagemEN'
}
